import MonacoEditor from '@monaco-editor/react';
import { KaceyView } from '../../types';
import { useRef, useState } from 'react';
import { CheckOutlined, CopyOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { useTimeout } from 'ahooks';

function cutOrCopy(editor: any, isCut: boolean) {
    editor.focus();
    // Get the current selection in the editor.
    const selection = editor.getSelection();
    if (!selection || selection.isEmpty()) {
        navigator.clipboard.writeText("");
        return;
    }

    // Get the text from that selection.
    const data = editor.getModel()?.getValueInRange(selection);

    // Set the clipboard contents.
    navigator.clipboard.writeText(data || "");

    if (isCut) {
        // This is a cut operation, so replace the selection with an empty string.
        editor.executeEdits("clipboard", [{
            range: selection,
            text: "",
            forceMoveMarkers: true,
        }]);
    }
}

export const Code: KaceyView<{ height: string, value: string, language: string }> =
    ({ height, value, language }) => {
        const [editor, setEditor] = useState(undefined as any);
        const [showOk, setShowOk] = useState(false);

        const f = () => setTimeout(() => {
            setShowOk(false);
        }, 2000)

        const copy = () => {
            // editor.trigger('source','editor.action.clipboardCopyAction');
            navigator.clipboard.writeText(editor.getValue());
            setShowOk(true);
            f();
        };
        const onBeforeMount = (monaco: any) => {
            console.log(editor);
            monaco.languages.typescript.javascriptDefaults.setDiagnosticsOptions({
                // diagnosticCodesToIgnore: [2792,1109],
                noSemanticValidation: true,
                noSyntaxValidation: true,

            });
        }
        const onMount = (editor: any) => {
            setEditor(editor);
        }


        return <div style={{ position: "relative", marginTop: 12, marginBottom: 12, clear: "both" }}>
            <MonacoEditor
                options={{
                    minimap: { autohide: true },
                    lineNumbers: 'off',
                    padding: {
                        top: 16
                    }
                }}
                language={language || "typescript"}
                theme="vs-dark"
                value={value}
                
                height={`max(52px,${height || "1em"})`}
                onMount={onMount}
                beforeMount={onBeforeMount}
            />

            <Button onClick={copy} icon={showOk ? <CheckOutlined /> : <CopyOutlined />} style={{ position: "absolute", height: 40, width: 40, right: 6, top: 6 }} />
        </div>
    }